import {
  getLastReceipt,
  postStripePaymentIntentAction,
} from '@/api/index.js'

import {
  BCR_ACTIONS,
} from '@/components/settings/payments/payment-types/booksy-card-reader/consts.js'

import { useCore } from '@/composables/core'
import { useToast } from '@/composables/toast'

import { PAYMENT_TYPE } from '@/components/sales/checkout/consts.js'

export async function getPaymentIntent (
  transactionId: number,
  isPendingCancel = true
): Promise<string | undefined> {
  const { store, t } = useCore()
  const toast = useToast()
  const businessId = store.getters['business/businessId']

  try {
    const response = await getLastReceipt(businessId, transactionId)
    const { receipt } = response.data

    if (isPendingCancel) {
      // if user wants to cancel the payment, get row from bcr or ttp
      // otherwise take the first one
      return receipt.payment_rows.find(row => row.payment_intent
        && [PAYMENT_TYPE.BOOKSY_CARD_READER, PAYMENT_TYPE.TAP_TO_PAY].includes(row.payment_type_code))?.payment_intent
    }
    return receipt.payment_rows.find(row => row.payment_intent)?.payment_intent
  } catch (error) {
    toast.error(error.response?.data?.errors?.[0].description || t('error'))
  }
}

export async function cancelPaymentIntent (paymentIntentId: string): Promise<void> {
  const { store, t } = useCore()
  const toast = useToast()
  const businessId = store.getters['business/businessId']

  try {
    await postStripePaymentIntentAction({ businessId, paymentIntentId, action: BCR_ACTIONS.CANCEL })
  } catch (error) {
    toast.error(error.response?.data?.errors?.[0].description || t('error'))
  }
}
